import axios from '@/libs/api.request'


//保存岗位信息
export const savePositionInfo = async (data) => {

    return axios.request({
        url: '/shop/talent/savePositionInfo',
        data,
        method: 'post'
    })

}

//获取岗位列表
export const getAllPositionInfo= async (data) => {

    return axios.request({
        url: '/shop/talent/getAllPositionInfo',
        data,
        method: 'post'
    })

}
//获取指定岗位的信息
export const getPositionInfoById= async (data) => {
    return axios.request({
        url: '/shop/talent/getPositionInfoById',
        data,
        method: 'post'
    })
}
//删除岗位信息
export const delPositionInfoById= async (data) => {
    return axios.request({
        url: '/shop/talent/delPositionInfoById',
        data,
        method: 'post'
    })
}

export const saveTalentBaseInfo= async (data) => {

    return axios.request({
        url: '/shop/talent/saveTalentBaseInfo',
        data,
        method: 'post'
    })
}

//保存上传的简历
export const saveUploadResumeInfo= async (data) => {

    return axios.request({
        url: '/shop/talent/saveUploadResumeInfo',
        data,
        method: 'post'
    })
}

//保存初筛结果
export const savefirstFiltrateInfo = async (data) => {

    return axios.request({
        url: '/shop/talent/saveFirstFiltrateInfo',
        data,
        method: 'post'
    })
}

//获取所有的人才信息
export const getAllTalentInfo = async (data) => {

    return axios.request({
        url: '/shop/talent/searchTalentInfo',
        data,
        method: 'post'
    })
}

//获取具体人才的信息
export const getTalentInfoByTalentId = async (data) => {

    return axios.request({
        url: '/shop/talent/getTalentInfoByTalentId',
        data,
        method: 'post'
    })
}

//保存一面信息
export const saveFirstInterview = async (data) => {
    return axios.request({
        url: '/shop/talent/saveFirstInterviewInfo',
        data,
        method: 'post'
    })
}
//保存二面信息
export const saveSecondInterview = async (data) => {
    return axios.request({
        url: '/shop/talent/saveSecondInterviewInfo',
        data,
        method: 'post'
    })
}

//搜索人才
export const getTalentSearchResult = async (data) => {
    return axios.request({
        url: '/shop/talent/searchTalentInfo',
        data,
        method: 'post'
    })
}



